import React, { useMemo, useState } from 'react';
import Heading from '../../../../../../generic-components/Heading';
import Icon from '../../../../../../generic-components/Icon';
import CloseIcon from '../../../../../../assets/svg/x-icon-v2.svg';
import { Input } from '../../../../../../generic-components/Input';
import Button from '../../../../../../generic-components/Button';
import { INPUT_REPLACE_TYPES } from '../../../../../../generic-components/Input/constants';
import { useStore } from '../../../../../../store';

interface IProps {
  onClose: () => void;
}

const MAX_TAX_RATE = 30;

export const EditSalesTaxForm = ({ onClose }: IProps) => {
  const [taxValue, setTaxValue] = useState<number>(0);
  const invoiceData = useStore((state) => state.invoiceData);
  const setInvoiceDataToUpdate = useStore((state) => state.setInvoiceDataToUpdate);

  const handleSubmit = () => {
    if (invoiceData) {
      const invoiceDataToUpdate = { ...invoiceData };
      if (invoiceDataToUpdate?.invoiceService) {
        invoiceDataToUpdate.invoiceService.salesTax = taxValue / 100;
        setInvoiceDataToUpdate(invoiceData);
      }
    }
  };

  const isSubmitAble = useMemo(() => {
    if (!taxValue) return false;
    if (taxValue > MAX_TAX_RATE) return false;
    return true;
  }, [taxValue]);

  const isTaxRateOverLimit = useMemo(() => {
    if (taxValue > MAX_TAX_RATE) return true;
    return false;
  }, [taxValue]);

  const handleChange = (data: any) => {
    const cleanValue = data.value.replace(/[^0-9.]+/g, '');
    setTaxValue(Number(cleanValue));
  };

  return (
    <div className='flex flex-col py-[24px] px-[24px]'>
      <div className='flex items-center justify-between grow'>
        <Heading title='Add Tax Rate' className='font-metricRSemibold text-[24px] text-bw08 mb-[4px]' />
        <Icon onClick={onClose} src={CloseIcon} />
      </div>
      <Heading
        title='This tax rate will be calculated for the total amount of the invoice'
        className='font-metric text-bw07 text-[16px] mb-[20px]'
      />
      <div className='flex items-start w-full gap-[20px]'>
        <div className='basis-[100%]'>
          <Input
            replace={INPUT_REPLACE_TYPES.PERCENT}
            onChange={handleChange}
            title='Tax Rate (%)'
            maxPrice={30}
            type='salesTax'
            isError={isTaxRateOverLimit}
            error='Maximum tax rate (30%) exceeded'
            validation=''
            shouldValidate={false}
            id=''
          />
        </div>
      </div>
      <div className='flex items-center justify-end grow gap-[12px]'>
        <Button
          onClick={onClose}
          className='rounded-[4px] py-[10px] px-[30px] font-metricRSemibold text-[14px] text-action03 bg-action01'
          id=''
          title='Cancel'
        />
        <Button
          disable={!isSubmitAble}
          onClick={handleSubmit}
          className={`rounded-[4px] py-[10px] px-[30px] font-metricRSemibold text-bw00 text-[14px] ${isSubmitAble ? ' bg-action03 hover:bg-action04' : ' bg-bw05'}  `}
          id=''
          title='Apply'
        />
      </div>
    </div>
  );
};
